<script setup>
import { onMounted, onBeforeUnmount, watch, ref, useSlots } from 'vue'
import mapboxgl from 'mapbox-gl'

const props = defineProps({
  map: {
    type: Object,
    required: true
  },
  coordinates: {
    type: Array,
    required: false,
    default: () => []
  },
  offset: {
    type: [Number, Object, Array],
    required: false,
    default: 0
  },
  anchor: {
    type: String,
    required: false,
    default: 'bottom'
  },
  closeButton: {
    type: Boolean,
    required: false,
    default: true
  },
  closeOnClick: {
    type: Boolean,
    required: false,
    default: true
  },
  maxWidth: {
    type: String,
    required: false,
    default: '300px'
  },
  minWidth: {
    type: String,
    required: false,
    default: '300px'
  },
  className: {
    type: String,
    required: false,
    default: ''
  },
  show: {
    type: Boolean,
    required: false,
    default: false
  }
})

const emit = defineEmits(['close'])
const slots = useSlots()
const popup = ref(null)
const popupContainer = ref(null)

const showPopup = () => {
  if (!popup.value || !props.map || props.coordinates.length !== 2) return

  popup.value.setLngLat(props.coordinates).addTo(props.map)
}

onMounted(() => {
  popup.value = new mapboxgl.Popup({
    offset: props.offset,
    anchor: props.anchor,
    closeButton: props.closeButton,
    closeOnClick: props.closeOnClick,
    maxWidth: props.maxWidth,
    minWidth: props.minWidth,
    className: props.className
  })

  popup.value.on('close', () => {
    emit('close')
  })

  if (popupContainer.value) {
    popup.value.setDOMContent(popupContainer.value)
  }

  if (props.show && props.coordinates.length === 2) {
    showPopup()
  }
})

watch(() => props.show, (newVal) => {
  if (!popup.value || !props.map) return

  if (newVal && props.coordinates.length === 2) {
    showPopup()
  } else {
    popup.value.remove()
  }
}, { immediate: true })

watch(() => props.coordinates, (newVal, oldVal) => {
  if (!popup.value || !props.map) return

  if (newVal.length === 2 &&
      (oldVal.length !== 2 ||
       newVal[0] !== oldVal[0] ||
       newVal[1] !== oldVal[1])) {

    popup.value.setLngLat(newVal)

    if (props.show && !popup.value.isOpen()) {
      popup.value.addTo(props.map)
    }
  }
}, { deep: true })

onBeforeUnmount(() => {
  if (popup.value) {
    popup.value.remove()
    popup.value = null
  }
})
</script>

<template>
  <div>
    <div ref="popupContainer">
      <slot />
    </div>
  </div>
</template>

<style scoped>
</style>
